export const ERROR_MESSAGE = {
  maxLength: "{{field}}は{{max}}文字以下で入力してください",
  minLength: "{{field}}は{{min}}文字以上で入力してください",
  required: "{{field}}は必須項目です",
  validToDate: "{{field}}は過去の日付を指定してください",
  validFromDate: "{{field}}は未来の日付を指定してください",
  invalidEmail: "メールアドレスの形式で入力してください",
  invalidPhoneNumber: "電話番号が正しくありません",
};
// 変数を変換する
// テンプレート関数
export const formatErrorMessage = (
  template: string,
  params: Record<string, string>,
) => {
  let message = template;
  for (const key in params) {
    message = message.replace(`{{${key}}}`, params[key]);
  }
  return message;
};
